import { useMemo } from 'react'
import { SegmentedControl } from 'ui'
import { strokeLabel, strokeWidth, ugeStrokeSizes } from '../../../types/stroke-size'
import { Label } from '../../style'
import Color from './color'
import { StrokeOptions } from './style'

const STROKE_SIZES = ugeStrokeSizes.map(strokeLabel)

type Props = {
    color?: string
    strokeSize?: number
    onColorChange?: (color: string) => void
    onSizeChange?: (size?: number) => void
}

const CaptionEditorStyleOptionsColor = ({ color, strokeSize = 0, onColorChange, onSizeChange }: Props) => {
    const defaultStrokeSizeIndex: number = useMemo(() => {
        const index = ugeStrokeSizes.findIndex((size) => {
            if (strokeWidth(size) === strokeSize) {
                return true
            }
            return false
        })

        return Math.max(index, 0)
    }, [strokeSize])

    return (
        <Color
            color={color}
            icon={!color || !strokeSize ? 'stroke-off' : 'stroke'}
            label="Outline Color"
            onChange={onColorChange}
        >
            <StrokeOptions>
                <Label>Thickness</Label>
                <SegmentedControl
                    defaultIndex={defaultStrokeSizeIndex}
                    options={STROKE_SIZES}
                    onChange={onSizeChange}
                />
            </StrokeOptions>
        </Color>
    )
}

export default CaptionEditorStyleOptionsColor
